import(/* webpackMode: "eager" */ "/codebuild/output/src1241461382/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/not-found.tsx");
